if (!customElements.get('product-description-toggle')) {
  customElements.define('product-description-toggle', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      const content = this.querySelector('[data-description-content]');
      const toggle = this.querySelector('[data-description-toggle]');
      if (!content || !toggle) return;

      const blocks = Array.from(content.children);
      const introductionIndex = blocks.findIndex((element) =>
        element.matches('p') && element.textContent.trim()
      );
      if (introductionIndex === -1) return;

      // Keep the introduction and its following subheading visible above the control.
      const boundary = blocks.slice(introductionIndex + 1).find((element) =>
        element.matches('h2, h3, h4, h5, h6')
      ) || blocks[introductionIndex];

      const remainingNodes = [];
      for (let node = boundary.nextSibling; node; node = node.nextSibling) {
        remainingNodes.push(node);
      }
      if (!remainingNodes.some((node) => node.textContent.trim())) return;

      this.full = document.createElement('div');
      this.full.className = 'product-description__full';
      this.full.id = toggle.getAttribute('aria-controls');
      content.insertBefore(this.full, boundary.nextSibling);
      remainingNodes.forEach((node) => this.full.appendChild(node));

      // Keep See more above the hidden content. See less moves below the
      // complete description when the content is expanded.
      content.insertBefore(toggle, this.full);
      this.toggle = toggle;
      this.moreLabel = toggle.querySelector('[data-description-more]');
      this.lessLabel = toggle.querySelector('[data-description-less]');
      this.initialized = true;
      this.setExpanded(false);
      toggle.hidden = false;

      toggle.addEventListener('click', () => {
        this.setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
      });
    }

    setExpanded(expanded) {
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.moreLabel.hidden = expanded;
      this.lessLabel.hidden = !expanded;
      this.full.hidden = !expanded;

      if (expanded) {
        this.full.after(this.toggle);
      } else {
        this.full.before(this.toggle);
      }
    }
  });
}
